import { IApiThreadsResult } from 'affiny-core/modules/api/models/thread';
import { paginatedRequest } from 'affiny-core/modules/helpers';
import { EAffinyEventOrigin } from '../affiny.eventorigins';
import { AffinyEndpoint } from '../affinyEndpoints/affiny.endpoints';

export const ThreadsResource = {
  getThreadsByAccountId: (
    accountId: string,
    pageNumber: number,
    pageSize: number
  ) =>
    paginatedRequest<IApiThreadsResult>({
      apiEndPoint: AffinyEndpoint.Thread.url(`/${accountId}/`),
      pageNumber,
      pageSize,
    }),
  setThreadAsRead: (
    myAccountId: string,
    otherAccountId: string,
    threadId: string,
    messageId: string
  ) =>
    AffinyEndpoint.Thread.url(`/${myAccountId}/${threadId}/`)
      .headers({ 'X-Event-Origin': EAffinyEventOrigin.W_BAL })
      .patch({
        data: {
          attributes: {
            readByMe: true,
            messageId,
            contactId: otherAccountId,
          },
          type: 'thread',
        },
      })
      .res(),
};
